/*
 * Constants to represent default factors in metrics.
 */
const METRIC_CONSTANTS = {
    defaultCo2EfficiencyFactor: 0.1,
    defaultPaybackFactor: 6,
    co2EfficiencyScalingFactor: 1000000,
}

export default METRIC_CONSTANTS
